import { ArrowRight, MoveDown } from "lucide-react";
import { siteContent } from "@/data/siteContent";

export const HeroSection = () => {
  const { hero } = siteContent;

  return (
  <section className="hero-section" aria-labelledby="hero-title" data-testid="hero-section">
    <div className="site-container">
      <div className="hero-content">
        <p className="hero-eyebrow" data-testid="hero-eyebrow">{hero.kicker}</p>
        <h1 id="hero-title" className="display-title hero-question-title" data-testid="hero-title">{hero.heading}</h1>
        <p className="hero-copy" data-testid="hero-supporting-copy">
          {hero.supportingText.map((line) => <span className="copy-line" key={line}>{line}</span>)}
        </p>
        <div className="hero-actions" data-testid="hero-actions">
          <a className="primary-link" href={hero.primaryCta.destination} data-testid="hero-primary-cta">
            {hero.primaryCta.label} <ArrowRight size={17} aria-hidden="true" />
          </a>
          <a className="secondary-link" href={hero.secondaryCta.destination} data-testid="hero-secondary-cta">
            {hero.secondaryCta.label} <MoveDown size={16} aria-hidden="true" />
          </a>
        </div>
        <div className="hero-context" aria-label="Areas of life" data-testid="hero-context-topics">
          {hero.topics.map((topic) => <span key={topic}>{topic}</span>)}
        </div>
      </div>
    </div>
  </section>
  );
};